import moment from 'moment';
import { showErrorDialog } from '@/components/showDialog.js';
import { tagUrl, broadcastUrls } from '../utils/urls';
import { postData, getData } from '@/utils/apiHelper.js';

export default {
  data() {
    return {
      model: {
        include_mainselect: '',
        exclude_mainselect: '',
        include_condition: 'AND',
        exclude_condition: 'AND',
        includesparams: [],
        excludesparams: [],
        includelist: '',
        includetag: '',
        includeform: '',
        includesegment: '',
        includecategory: '',
        includesequence: '',
        includeip: '',
        includestatus: '',
        includedaterange: {
          startDate: moment('19700101', 'YYYYMMDD'),
          endDate: moment(),
        },
        includecampaign: '',
        includecampaignlink: '',
        excludelist: '',
        excludetag: '',
        excludeform: '',
        excludesegment: '',
        excludecategory: '',
        excludesequence: '',
        excludeip: '',
        excludestatus: '',
        excludedaterange: {
          startDate: moment('19700101', 'YYYYMMDD'),
          endDate: moment(),
        },
        excludecampaign: '',
        excludecampaignlink: '',
      },
      includefiltertags: [],
      excludefiltertags: [],
      inaddbtndisabled: true,
      exaddbtndisabled: true,
      includesname: [],
      excludesname: [],
      includelistname: '',
      includetagname: '',
      includeformname: '',
      includesequencename: '',
      includeipname: '',
      includestatusname: '',
      includedaterangename: '',
      includecampaignname: '',
      includecampaignlinkname: '',
      includesegmentname: '',
      excludelistname: '',
      excludetagname: '',
      excludeformname: '',
      excludesegmentname: '',
      excludesequencename: '',
      excludeipname: '',
      excludestatusname: '',
      excludedaterangename: '',
      excludecampaignname: '',
      excludecampaignlinkname: '',
      includemainselectname: '',
      excludemainselectname: '',
      lists: [],
      forms: [],
      categories: [],
      sequences: [],
      campaigns: [],
      includelinks: [],
      excludelinks: [],
      dateFormat: 'MM/DD/YYYY',
      subscribe_everybody: 'Everybody in my database',
    };
  },

  computed: {
    /**
     * Returns list of first exclude condition data.
     * @return {array} - array of data based on main select condition.
     */
     firstExcludeConditionData() {
      switch (this.model.exclude_mainselect) {
        case 'subscribedlist':
        case 'notsubscribedlist':
          return this.lists;
        case 'hasform':
          return this.forms;
        case 'subscribedsegment':
            return this.segments;
        case 'hastag':
        case 'notag':
          return this.categories;
        case 'subscribedsequence':
          return this.sequences;
        case 'hasstatus':
          return this.statuses;
        case 'openbroadcast':
        case 'clickbroadcast':
          return this.campaigns;
        default:
          return null;
      }
    },

    /**
     * Returns list of first include condition data .
     * @return {object} - array of data based on include main select condition.
     */
     firstIncludeConditionData() {
      switch (this.model.include_mainselect) {
        case 'subscribedlist':
        case 'notsubscribedlist':
          return this.lists;
        case 'hasform':
          return this.forms;
        case 'subscribedsegment':
          return this.segments;
        case 'hastag':
        case 'notag':
          return this.categories;
        case 'subscribedsequence':
          return this.sequences;
        case 'hasstatus':
          return this.statuses;
        case 'openbroadcast':
        case 'clickbroadcast':
          return this.campaigns;
        default:
          return null;
      }
    },

    /**
     * Returns first exclude condition data that is selected.
     * @return {string} - data based on main select condition.
     */
     fetchFirstExcludeCondition() {
      switch (this.model.exclude_mainselect) {
        case 'subscribedlist':
        case 'notsubscribedlist':
          return this.model.excludelist;
        case 'hasform':
          return this.model.excludeform;
        case 'hastag':
        case 'notag':
          return this.model.excludecategory;
        case 'subscribedsegment':
          return this.model.excludesegment;
        case 'subscribedsequence':
          return this.model.excludesequence;
        case 'hasip':
          return this.model.excludeip;
        case 'hasstatus':
          return this.model.excludestatus;
        case 'indaterange':
          return this.model.excludedaterange;
        case 'openbroadcast':
        case 'clickbroadcast':
          return this.model.excludecampaign;
        default:
          return '';
      }
    },

    /**
     * Returns first include condition data that is selected.
     * @return {string} - data based on main select condition.
     */
     fetchFirstIncludeCondition() {
      switch (this.model.include_mainselect) {
        case 'subscribedlist':
        case 'notsubscribedlist':
          return this.model.includelist;
        case 'hasform':
          return this.model.includeform;
        case 'hastag':
        case 'notag':
          return this.model.includecategory;
        case 'subscribedsegment':
          return this.model.includesegment;
        case 'subscribedsequence':
          return this.model.includesequence;
        case 'hasip':
          return this.model.includeip;
        case 'hasstatus':
          return this.model.includestatus;
        case 'indaterange':
          return this.model.includedaterange;
        case 'openbroadcast':
        case 'clickbroadcast':
          return this.model.includecampaign;
        default:
          return '';
      }
    },

    /**
     * Returns list of second exclude condition data.
     * @return {object} - array of data based on main select condition.
     */
     secondExcludeConditionData() {
      switch (this.model.exclude_mainselect) {
        case 'hastag':
        case 'notag':
          return this.excludefiltertags;
        case 'clickbroadcast':
          return this.excludelinks;
        default:
          return null;
      }
    },

    /**
     * Returns list of second include condition data.
     * @return {object} - array of data based on main select condition.
     */
     secondIncludeConditionData() {
      switch (this.model.include_mainselect) {
        case 'hastag':
        case 'notag':
          return this.includefiltertags;
        case 'clickbroadcast':
          return this.includelinks;
        default:
          return null;
      }
    },

    /**
     * Returns second exclude condition data that is selected.
     * @return {string} - data based on main select condition.
     */
     fetchSecondExcludeCondition() {
      switch (this.model.exclude_mainselect) {
        case 'hastag':
        case 'notag':
          return this.model.excludetag;
        case 'clickbroadcast':
          return this.model.excludecampaignlink;
        default:
          return '';
      }
    },

    /**
     * Returns second include condition data that is selected.
     * @return {string} - data based on main select condition.
     */
     fetchSecondIncludeCondition() {
      switch (this.model.include_mainselect) {
        case 'hastag':
        case 'notag':
          return this.model.includetag;
        case 'clickbroadcast':
          return this.model.includecampaignlink;
        default:
          return '';
      }
    },

    /**
     * Returns list of statuses.
     * @return {object} - array of object containing list of status.
     */
     statuses() {
      return [
        {
          id: '0',
          name: this.$t(
            'frontend_groovemail_lead_listing_advanced_filters_status_all'
          ),
        },
        {
          id: 1,
          name: this.$t(
            'frontend_groovemail_lead_listing_advanced_filters_status_subscribed'
          ),
        },
        {
          id: 2,
          name: this.$t(
            'frontend_groovemail_lead_listing_advanced_filters_status_unsubscribed'
          ),
        },
        {
          id: 3,
          name: this.$t(
            'frontend_groovemail_lead_listing_advanced_filters_status_verified'
          ),
        },
        {
          id: 4,
          name: this.$t(
            'frontend_groovemail_lead_listing_advanced_filters_status_unverified'
          ),
        },
        {
          id: 5,
          name: this.$t(
            'frontend_groovemail_lead_listing_advanced_filters_status_blocklisted'
          ),
        },
      ];
    },

    /**
     * Returns binary conditions.
     * @return {array} - array of objects containing binary condition details( AND/OR).
     */
     binaryConditionData() {
      return [
        {
          value: 'AND',
          name: this.$t('frontend_groovemail_segment_and'),
        },
        {
          value: 'OR',
          name: this.$t('frontend_groovemail_segment_or'),
        },
      ];
    },

  },

  methods: {
    /**
     * Sets id & name from the data selected when first included condition updated &
     * also enables or disables included conditions add button.
     * @param {object} conditionData contains unique id from  data selected & event triggered when first included condition changed.
     */
     firstIncludedConditionUpdated(conditionData) {
      if (this.model.include_mainselect === 'subscribedlist'  || this.model.include_mainselect === 'notsubscribedlist') {
        this.model.includelist = conditionData.condData;
        this.includeList(conditionData.event);
      } else if (this.model.include_mainselect === 'hastag' ||	 this.model.include_mainselect === 'notag') {
        this.model.includecategory = conditionData.condData;
        this.includeCategory(conditionData.event);
      } else if (this.model.include_mainselect === 'hasform') {
        this.model.includeform = conditionData.condData;
        this.includeForm(conditionData.event);
      } else if (this.model.include_mainselect === 'subscribedsegment') {
        this.model.includesegment = conditionData.condData;
        this.includeSegment(conditionData.event);
      } else if (this.model.include_mainselect === 'subscribedsequence') {
        this.model.includesequence = conditionData.condData;
        this.includeSequence(conditionData.event);
      } else if (this.model.include_mainselect === 'hasip') {
        this.model.includeip = conditionData.condData;
        this.includeIP(conditionData.event);
      } else if (
        this.model.include_mainselect === 'openbroadcast' ||
        this.model.include_mainselect === 'clickbroadcast'
      ) {
        this.model.includecampaign = conditionData.condData;
        this.includeCampaign(conditionData.event);
      } else if (this.model.include_mainselect === 'indaterange') {
        const daterange = `${moment(conditionData.condData.startDate).format(
          this.dateFormat
        )}-${moment(conditionData.condData.endDate).format(this.dateFormat)}`;
        this.model.includedaterange = daterange;
        this.includeDateRange(daterange);
      } else if (this.model.include_mainselect === 'hasstatus') {
        this.model.includestatus = conditionData.condData;
        this.includeStatus(conditionData.event);
      }
    },

    /**
     * Sets id & name from the data selected when second included condition updated (only in case from tags & click broadcast main conditions) &
     * also enables or disables included conditions add button.
     * @param {object} conditionData contains unique id from selected data & event triggered when second included condition changed.
     */
     secondIncludedConditionUpdated(conditionData) {
      if (
        this.model.include_mainselect === 'hastag' ||
        this.model.include_mainselect === 'notag'
      ) {
        this.model.includetag = conditionData.condData;
        this.includeTag(conditionData.event);
      } else if (this.model.include_mainselect === 'clickbroadcast') {
        this.model.includecampaignlink = conditionData.condData;
        this.includeCampaignLink(conditionData.event);
      }
    },

    /**
     * Sets id & name from the data selected when first excluded condition updated &
     * also enables or disables excluded conditions add button.
     * @param {object} conditionData contains unique id of selected data & event triggered when first excluded condition changed.
     */
     firstExcludedConditionUpdated(conditionData) {
      if (
        this.model.exclude_mainselect === 'subscribedlist' ||
        this.model.exclude_mainselect === 'notsubscribedlist'
      ) {
        this.model.excludelist = conditionData.condData;
        this.excludeList(conditionData.event);
      } else if (
        this.model.exclude_mainselect === 'hastag' ||
        this.model.exclude_mainselect === 'notag'
      ) {
        this.model.excludecategory = conditionData.condData;
        this.excludeCategory(conditionData.event);
      } else if (this.model.exclude_mainselect === 'hasform') {
        this.model.excludeform = conditionData.condData;
        this.excludeForm(conditionData.event);
      } else if (this.model.exclude_mainselect === 'subscribedsegment') {
        this.model.excludesegment = conditionData.condData;
        this.excludeSegment(conditionData.event);
      } else if (this.model.exclude_mainselect === 'subscribedsequence') {
        this.model.excludesequence = conditionData.condData;
        this.excludeSequence(conditionData.event);
      } else if (this.model.exclude_mainselect === 'hasip') {
        this.model.excludeip = conditionData.condData;
        this.excludeIP(conditionData.event);
      } else if (
        this.model.exclude_mainselect === 'openbroadcast' ||
        this.model.exclude_mainselect === 'clickbroadcast'
      ) {
        this.model.excludecampaign = conditionData.condData;
        this.excludeCampaign(conditionData.event);
      } else if (this.model.exclude_mainselect === 'indaterange') {
        const daterange = `${moment(conditionData.condData.startDate).format(
          this.dateFormat
        )}-${moment(conditionData.condData.endDate).format(this.dateFormat)}`;
        this.model.excludedaterange = daterange;
        this.excludeDateRange(daterange);
      } else if (this.model.exclude_mainselect === 'hasstatus') {
        this.model.excludestatus = conditionData.condData;
        this.excludeStatus(conditionData.event);
      }
    },

    /**
     * Sets id & name from the selected data when second excluded condition updated (only in case of tags & click broadcast main conditions) &
     * also enables or disables excluded conditions add button.
     * @param {object} conditionData contains unique id of selected data & event triggered when second excluded condition changed.
     */
     secondExcludedConditionUpdated(conditionData) {
      if (
        this.model.exclude_mainselect === 'hastag' ||
        this.model.exclude_mainselect === 'notag'
      ) {
        this.model.excludetag = conditionData.condData;
        this.excludeTag(conditionData.event);
      } else if (this.model.exclude_mainselect === 'clickbroadcast') {
        this.model.excludecampaignlink = conditionData.condData;
        this.excludeCampaignLink(conditionData.event);
      }
    },

    /**
     * Sets include list name from list data selected when first included condition changes &
     * also enables or disables include add button if data is selected or not.
     * @param {object} e contains updated list data after change event triggers.
     */
    includeList(e) {
      this.includelistname =
      e.target.options[e.target.options.selectedIndex].dataset.name;
      this.inaddbtndisabled = this.model.includelist === '';
    },

    /**
     * Sets exclude list name from list data selected when first exclude condition changes &
     * also enables or disables exclude add button if data is selected or not.
     * @param {object} e contains updated list data after change event triggers.
     */
     excludeList(e) {
      this.excludelistname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.exaddbtndisabled = this.model.excludelist === '';
    },

    /**
     * Sets include tag name from tag data selected when second include condition changes &
     * also enables or disables include add button if data is selected or not.
     * @param {object} e contains updated tag data after change event triggers.
     */
     includeTag(e) {
      this.includetagname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.inaddbtndisabled = this.model.includetag === '';
    },

    /**
     * Sets exclude tag name from tag data selected when second exclude condition changes &
     * also enables or disables exclude add button if data is selected or not.
     * @param {object} e contains updated tag data after change event triggers.
     */
     excludeTag(e) {
      this.excludetagname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.exaddbtndisabled = this.model.excludetag === '';
    },

    /**
     * Sets include form name from form data selected when first include condition changes &
     * also enables or disables include add button if data is selected or not.
     * @param {object} e contains updated form data after change event triggers.
     */
     includeForm(e) {
      this.includeformname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.inaddbtndisabled = this.model.includeform === '';
    },

    /**
     * Sets exclude form name from form data selected when first exclude condition changes &
     * also enables or disables exclude add button if data is selected or not.
     * @param {object} e contains updated form data after change event triggers.
     */
     excludeForm(e) {
      this.excludeformname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.exaddbtndisabled = this.model.excludeform === '';
    },

    /**
     * Sets include sequence name from sequence data selected when first include condition changes &
     * also enables or disables include add button if data is selected or not.
     * @param {object} e contains updated form data after change event triggers.
     */
     includeSequence(e) {
      this.includesequencename =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.inaddbtndisabled = this.model.includesequence === '';
    },

    /**
     * Sets exclude sequence name from sequence data selected when first exclude condition changes &
     * also enables or disables exclude add button if data is selected or not.
     * @param {object} e contains updated sequence data after change event triggers.
     */
     excludeSequence(e) {
      this.excludesequencename =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.exaddbtndisabled = this.model.excludesequence === '';
    },

    /**
     * Sets include ip name from ip data selected when first include condition changes &
     * also enables or disables include add button if data is selected or not.
     * @param {object} e contains updated ip data after change event triggers.
     */
     includeIP(e) {
      this.includeipname = e;
      this.inaddbtndisabled = this.model.includeip === '';
    },

    /**
     * Sets exclude ip name from ip data selected when first exclude condition changes &
     * also enables or disables exclude add button if data is selected or not.
     * @param {object} e contains updated ip data after change event triggers.
     */
     excludeIP(e) {
      this.excludeipname = e;
      this.exaddbtndisabled = this.model.excludeip === '';
    },

    /**
     * Sets include status name from status data selected when first include condition changes &
     * also enables or disables include add button if data is selected or not.
     * @param {object} e contains updated  status data after change event triggers.
     */
     includeStatus(e) {
      this.includestatusname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.inaddbtndisabled = this.model.includestatus === '';
    },

    /**
     * Sets exclude status name from status data selected when first exclude condition changes &
     * also enables or disables exclude add button if data is selected or not.
     * @param {object} e contains updated status data after change event triggers.
     */
     excludeStatus(e) {
      this.excludestatusname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.exaddbtndisabled = this.model.excludestatus === '';
    },

    /**
     * Sets include date range name from date range data selected when first include condition changes &
     * also enables or disables include add button if data is selected or not.
     * @param {object} e contains updated date range data after change event triggers.
     */
     includeDateRange(e) {
      this.includedaterangename = e;
      this.inaddbtndisabled = this.model.includedaterange === '';
    },

    /**
     * Sets exclude date range name from date range data selected when first exclude condition changes &
     * also enables or disables exclude add button if data is selected or not.
     * @param {object} e contains updated date range data after change event triggers.
     */
     excludeDateRange(e) {
      this.excludedaterangename = e;
      this.exaddbtndisabled = this.model.excludedaterange === '';
    },

    /**
     * Sets include campaign name from campaign data selected when first include condition changes &
     also enables or disables include add button if data is selected or not.
     * @param {object} e contains updated campaign data after change event triggers.
     */
     async includeCampaign(e) {
      this.includecampaignname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      if (this.model.include_mainselect === 'openbroadcast') {
        this.inaddbtndisabled = this.model.includecampaign === '';
      } else if (this.model.include_mainselect === 'clickbroadcast') {
        const linksdata = await postData(`${broadcastUrls.trackingLink}`, { campaign_id: e.target.options[e.target.options.selectedIndex].value });
        this.includelinks = [];
        if (linksdata.data && linksdata.data.length) {
          linksdata.data.forEach((ele) => {
            const linkObj = {
              id: ele.id,
              name: ele.source_id,
              linkName: ele.redirect_url,
            };
            this.includelinks.push(linkObj);
          });
        }
        this.inaddbtndisabled = true;
      }
    },


    /**
     * Sets exclude campaign name from campaign data selected when first exclude condition changes &
     * also enables or disables exclude add button if data is selected or not.
     * @param {object} e contains updated campaign data after change event triggers.
     */
     async excludeCampaign(e) {
      this.excludecampaignname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      if (this.model.exclude_mainselect === 'openbroadcast') {
        this.exaddbtndisabled = this.model.excludecampaign === '';
      } else if (this.model.exclude_mainselect === 'clickbroadcast') {
        const linksdata = await postData(`${broadcastUrls.trackingLink}`, { campaign_id: e.target.options[e.target.options.selectedIndex].value });
        this.excludelinks = [];
        if (linksdata.data && linksdata.data.length) {
          linksdata.data.forEach((ele) => {
            const linkObj = {
              id: ele.id,
              name: ele.source_id,
              linkName: ele.redirect_url,
            };
            this.excludelinks.push(linkObj);
          });
        }
        this.exaddbtndisabled = true;
      }
    },

    /**
     * Sets include campaign link name from campaign link data selected when second include condition changes &
     * also enables or disables include add button if data is selected or not.
     * @param {object} e contains updated campaign link data after change event triggers.
     */
     includeCampaignLink(e) {
      this.includecampaignlinkname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.inaddbtndisabled = this.model.includecampaignlink === '';
    },

    /**
     * Sets exclude campaign link name from campaign data selected when second exclude condition changes &
     * also enables or disables exclude add button if data is selected or not.
     * @param {object} e contains updated campaign link data after change event triggers.
     */
     excludeCampaignLink(e) {
      this.excludecampaignlinkname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.exaddbtndisabled = this.model.excludecampaignlink === '';
    },

    /**
     * Fetches include tag data based on include category data selected.
     * @param {object} e contains updated category data after change event triggers.
     */
     async includeCategory(e) {
      const self = this;
      self.includefiltertags = [];
      const { data } = await getData(`${tagUrl.tag}`, { params: { category: e.target.value } });
      if (data && data.length > 0) {
        self.includefiltertags = data;
      }
    },

    /**
     * Fetches exclude tag data based on exclude category data selected.
     * @param {object} e contains updated category data after change event triggers.
     */
     async excludeCategory(e) {
      const self = this;
      self.excludefiltertags = [];
      const { data } = await getData(`${tagUrl.tag}`, { params: { category: e.target.value } });
      if (data && data.length > 0) {
        self.excludefiltertags = data;
      }
    },

    /**
     * Checks if a filter is already selected or not.
     * @param {array} filtersArray - array of included or exculed conditions.
     * @param {string} filterId - unique id of selected filter.
     * @return {boolean} - present, boolean value that denote if a filter is already present or not.
     */
     checkFilterPresent(filtersArray, filterId) {
      let present = false;
      filtersArray.forEach((ele) => {
        if (ele.id === filterId) {
          present = true;
        }
      });
      return present;
    },

    /**
     * Add include condition to an array if its not already present.
     * @param {string} filterId - unique id of selected filter.
     * @param {string} filterName - name of selected filter.
     * @param {string} filterType - type of selected filter.
     */
     includeCondition(filterId, filterName, filterType) {
      const filterPresent = this.checkFilterPresent(
        this.model.includesparams,
        filterId
      );
      if (filterPresent) {
        showErrorDialog(
          '',
          this.$t('frontend_groovemail_filter_already_present_text')
        );
      } else {
        const listtxt = `${this.includemainselectname} ${filterName}`;
        this.includesname.push(listtxt);
        const operation =
          this.includemainselectname === this.subscribe_everybody
            ? ''
            : this.fetchOperation(this.model.include_mainselect);
        if (this.model.include_mainselect === 'clickbroadcast') {
          const linkObj = this.includelinks.find((ele) => {
            return ele.id === filterName;
          });
          this.model.includesparams.push({
            action: this.model.include_mainselect,
            type: 'broadcastclick',
            operation,
            id: linkObj.id,
            name: linkObj.name,
            linkName: linkObj.linkName,
          });
        } else {
          this.model.includesparams.push({
            action: this.model.include_mainselect,
            type: filterType,
            operation,
            id: filterId,
            name: filterName,
          });
        }
        this.inaddbtndisabled = true;
      }
    },


    // Add include condition to an array.
    async includeAddButton() {
      if (
        this.model.include_mainselect === 'subscribedlist' ||
        this.model.include_mainselect === 'notsubscribedlist'
      ) {
        this.includeCondition(
          this.model.includelist,
          this.includelistname,
          'list'
        );
      } else if (
        this.model.include_mainselect === 'hastag' ||
        this.model.include_mainselect === 'notag'
      ) {
        this.includeCondition(
          this.model.includetag,
          this.includetagname,
          'tag'
        );
      } else if (this.model.include_mainselect === 'subscribedsegment') {
        this.includeCondition(
          this.model.includesegment,
          this.includesegmentname,
          'segment'
        );
      } else if (this.model.include_mainselect === 'hasform') {
        this.includeCondition(
          this.model.includeform,
          this.includeformname,
          'form'
        );
      } else if (this.model.include_mainselect === 'subscribedsequence') {
        this.includeCondition(
          this.model.includesequence,
          this.includesequencename,
          'sequence'
        );
      } else if (this.model.include_mainselect === 'hasstatus') {
        this.includeCondition(
          this.model.includestatus,
          this.includestatusname,
          'status'
        );
      } else if (this.model.include_mainselect === 'indaterange') {
        this.includeCondition(
          this.model.includedaterange,
          this.includedaterangename,
          'daterange'
        );
      } else if (this.model.include_mainselect === 'hasip') {
        this.includeCondition(this.model.includeip, this.includeipname, 'ip');
      } else if (this.model.include_mainselect === 'openbroadcast') {
        this.includeCondition(
          this.model.includecampaign,
          this.includecampaignname,
          'broadcastopen'
        );
      } else if (this.model.include_mainselect === 'clickbroadcast') {
        this.includeCondition(
          this.model.includecampaignlink,
          this.includecampaignlinkname,
          'broadcastclick'
        );
      } else {
        this.includeCondition('', '', '');
        this.model.include_condition = '';
      }
    },

    /**
     * Add exclude condition to an array if its not already present.
     * @param {string} filterId - unique id of selected filter.
     * @param {string} filterName - name of selected filter.
     * @param {string} filterType - type of selected filter.
     */
     excludeCondition(filterId, filterName, filterType) {
      const filterPresent = this.checkFilterPresent(
        this.model.excludesparams,
        filterId
      );
      if (filterPresent) {
        showErrorDialog(
          '',
          this.$t('frontend_groovemail_filter_already_present_text')
        );
      } else {
        const listtxt = `${this.excludemainselectname} ${filterName}`;
        this.excludesname.push(listtxt);
        const operation =
          this.excludemainselectname === this.subscribe_everybody
            ? ''
            : this.fetchOperation(this.model.exclude_mainselect);

        if (this.model.exclude_mainselect === 'clickbroadcast') {
          const linkObj = this.excludelinks.find((ele) => {
            return ele.id === filterName;
          });
          this.model.excludesparams.push({
            action: this.model.exclude_mainselect,
            type: filterType,
            operation,
            id: linkObj.id,
            name: linkObj.name,
            linkName: linkObj.linkName,
          });
        } else {
          this.model.excludesparams.push({
            action: this.model.exclude_mainselect,
            type: filterType,
            operation,
            id: filterId,
            name: filterName,
          });
        }
        this.exaddbtndisabled = true;
      }
    },

    // Add exclude condition to an array
    async excludeAddButton() {
      if (
        this.model.exclude_mainselect === 'subscribedlist' ||
        this.model.exclude_mainselect === 'notsubscribedlist'
      ) {
        this.excludeCondition(
          this.model.excludelist,
          this.excludelistname,
          'list'
        );
      } else if (
        this.model.exclude_mainselect === 'hastag' ||
        this.model.exclude_mainselect === 'notag'
      ) {
        this.excludeCondition(
          this.model.excludetag,
          this.excludetagname,
          'tag'
        );
      } else if (this.model.exclude_mainselect === 'hasform') {
        this.excludeCondition(
          this.model.excludeform,
          this.excludeformname,
          'form'
        );
      } else if (this.model.exclude_mainselect === 'subscribedsegment') {
        this.excludeCondition(
          this.model.excludesegment,
          this.excludesegmentname,
          'segment'
        );
      } else if (this.model.exclude_mainselect === 'subscribedsequence') {
        this.excludeCondition(
          this.model.excludesequence,
          this.excludesequencename,
          'sequence'
        );
      } else if (this.model.exclude_mainselect === 'hasip') {
        this.excludeCondition(this.model.excludeip, this.excludeipname, 'ip');
      } else if (this.model.exclude_mainselect === 'hasstatus') {
        this.excludeCondition(
          this.model.excludestatus,
          this.excludestatusname,
          'status'
        );
      } else if (this.model.exclude_mainselect === 'indaterange') {
        this.excludeCondition(
          this.model.excludedaterange,
          this.excludedaterangename,
          'daterange'
        );
      } else if (this.model.exclude_mainselect === 'openbroadcast') {
        this.excludeCondition(
          this.model.excludecampaign,
          this.excludecampaignname,
          'broadcastopen'
        );
      } else if (this.model.exclude_mainselect === 'clickbroadcast') {
        this.excludeCondition(
          this.model.excludecampaignlink,
          this.excludecampaignlinkname,
          'broadcastclick'
        );
      } else {
        this.excludeCondition('', '', '');
        this.model.exclude_condition = '';
      }
    },

    /**
     * Delete include condition from an array.
     * @param {object} option - filter selected for deletion.
     */
     async deleteInclude(option) {
      const index = this.model.includesparams.indexOf(option);
      if (index > -1) {
        this.includesname.splice(index, 1);
        this.model.includesparams.splice(index, 1);
      }
    },

    /**
     * Delete exclude condition from an array.
     * @param {object} option - filter selected for deletion.
     */
     async deleteExclude(option) {
      const index = this.model.excludesparams.indexOf(option);
      if (index > -1) {
        this.excludesname.splice(index, 1);
        this.model.excludesparams.splice(index, 1);
      }
    },

    /**
     * Returns operation (!= or =) on the basis of main select condition.
     * @param {string} mainSelectCondition - include main select or exclude main select condition
     * @return {string} - returns operation ( != or =).
     */
     fetchOperation(mainSelectCondition) {
      const exp = mainSelectCondition;
      switch (exp) {
        case 'notsubscribedlist':
        case 'notag':
        case 'notform':
        case 'notsequence':
        case 'notstatus':
        case 'notdaterange':
        case 'notip':
        case 'notcampaign':
        case 'notcampaignlink':
          return '!=';
        default:
          return '=';
      }
    },
  },
};
